export const depthSpacingInPx = 100;
export const bgColour = '#1A202C';
export const controlSpacing = 4;

export const biomeList = [
    'Lush',
    'Toxic',
    'Scorched',
    'Radioactive',
    'Frozen',
    'Barren',
    'Dead',
    'Weird',
    'Red',
    'Green',
    'Blue',
    'Test',
    'Swamp',
    'Lava',
    'Waterworld',
    'All',
];

export const creatureType = [
    'None',
    'Bird',
    'FlyingLizard',
    'FlyingSnake',
    'Butterfly',
    'FlyingBeetle',
    'Beetle',
    'Fish',
    'Shark',
    'Crab',
    'Snake',
    'Dino',
    'Antelope',
    'Rodent',
    'Cat',
    'Fiend',
    'Drone',
    'Quad',
    'Walker',
    'Predator',
    'PlayerPredator',
    'Prey',
    'Passive',
    'FishPredator',
    'FishPrey',
    'FiendFishSmall',
    'FiendFishBig',
    'Jellyfish',
    'RockCreature',
    'MiniFiend',
    'Floater',
    'Scuttler',
    'Slug',
    'MiniDrone',
    'Weird',
    'SeaSnake',
    'SandWorm',
    'ProtoRoller',
    'ProtoFlyer',
    'ProtoDigger',
    'Plough',
    'Digger',
    'Drill',
    'Brainless',
    'Pet'
]